// extracted by mini-css-extract-plugin
export default {"container":"menu_container__X5PIO","item":"menu_item__B0siw","selected":"menu_selected__LXXXu"};